import type { Locale } from 'date-fns/locale';
import { enUS, es } from 'date-fns/locale';

export const FormatLocales: Record<string, Locale> = {
  es,
  en: enUS,
};
